/* eslint-disable eqeqeq */
import React, { useMemo } from 'react';
import momentTimezone from 'moment-timezone';
import { Flex, Box } from '@rebass/grid';
import { getTimeZoneFromAccounts } from 'helpers/date';
import { items } from 'components/CreateIncident/components/StatusSelect';
import Icon from 'components/Icons';
import { useTranslation } from 'react-i18next';
import Icons from '../Icons';
import { CardWrapper, AffectedComponents } from './style';

const getServiceInfo = affComponent => {
  const currentItem = items.find(i => i.id === affComponent.new_status);
  if (!currentItem) return null;
  return {
    name: affComponent.component_mini && affComponent.component_mini.name,
    icon: currentItem.icon
  };
};
const getComponentsByGroup = (components, componentsGroup, affected) => {
  const x = {};
  const compsWithoutGroup = [];
  affected.forEach(affectedComp => {
    const comp = components.find(c => c.component == affectedComp.component);
    const parentGroup = comp.component_mini.group;
    if (parentGroup) {
      x[parentGroup] = x[parentGroup]
        ? x[parentGroup].concat({
            ...comp,
            new_status: affectedComp.new_status
          })
        : [
            {
              ...comp,
              new_status: affectedComp.new_status
            }
          ];
    } else {
      compsWithoutGroup.push({ ...comp, new_status: affectedComp.new_status });
    }
  });
  return [x, compsWithoutGroup];
};
const IncidentCard = ({
  incidentType,
  currentAccount,
  incidentDetails,
  componentGroups,
  components
}: {
  incidentType: any,
  currentAccount: any,
  incidentDetails: any
}) => {
  const { t } = useTranslation();
  const timezone = getTimeZoneFromAccounts(currentAccount);
  const { affected_components, affected: affectedComps } = incidentDetails;
  const affected =
    affectedComps && affectedComps.length ? affectedComps : affected_components;
  const [compsWithGroup, compsWithoutGroup] = useMemo(() =>
    getComponentsByGroup(components, componentGroups, affected)
  );
  const startTime = momentTimezone
    .tz(new Date(incidentDetails.start), timezone)
    .format('MMM DD hh:mm a');
  const endTime = momentTimezone
    .tz(new Date(incidentDetails.end), timezone)
    .format('MMM DD hh:mm a');
  return (
    <CardWrapper p="30px">
      <Flex>
        <div className="breadcrump">
          <span className="home">
            {t('components.incidentCard.currentStatus')}
          </span>{' '}
          <span className="arrow">
            <Icons
              glyph="arrowdown"
              size="14"
              viewBox="3 0 32 32"
              style={{ transform: 'rotate(-90deg)' }}
            />
          </span>{' '}
          {incidentType === 'planned' ? 'Maintenance' : 'Incident'}
        </div>
      </Flex>
      <Flex>
        <Box>
          <div className="timestamp">
            {incidentType === 'planned'
              ? t('components.incidentCard.scheduleStartEndTimeStamp', {
                  start: startTime,
                  end: endTime
                })
              : t('components.incidentCard.scheduleStartTimeStamp', {
                  start: startTime
                })}
          </div>

          <h1 className="title">{incidentDetails.name}</h1>
        </Box>
      </Flex>
      <Flex>
        <Box>
          <div className="description">{incidentDetails.description}</div>
        </Box>
      </Flex>
      {affected ? (
        <AffectedComponents>
          <div id="name">{`Affected services (${affected.length})`}</div>
          <div id="list">
            <Flex mb="12px" style={{ flexWrap: 'wrap' }}>
              {compsWithoutGroup.map(comp => {
                const service = getServiceInfo(comp);
                return (
                  <div id="chip">
                    <Icon
                      size={15}
                      viewBox="0 0 16 16"
                      glyph={service.icon && service.icon.toLowerCase()}
                    />
                    <div>{service.name}</div>
                  </div>
                );
              })}
            </Flex>
            {Object.keys(compsWithGroup).map(eachGroup => {
              const group = componentGroups.find(
                eachG => eachG.id == eachGroup
              );
              const ancestor = componentGroups.find(
                eachG => eachG.id == group.parent
              );
              return (
                <Flex alignItems="center" mb="12px" flexWrap="wrap">
                  {ancestor ? (
                    <>
                      <div className="group-name">{ancestor.name}&nbsp;-</div>
                      <div className="sub-group-name">{group.name}&nbsp;-</div>
                    </>
                  ) : (
                    <div className="group-name">{group.name}&nbsp;-&nbsp;</div>
                  )}
                  <Flex style={{ flexWrap: 'wrap' }}>
                    {compsWithGroup[eachGroup].map(comp => {
                      const service = getServiceInfo(comp);
                      return (
                        <div id="chip">
                          <Icon
                            size={15}
                            viewBox="0 0 16 16"
                            glyph={service.icon && service.icon.toLowerCase()}
                          />
                          <div>{service.name}</div>
                        </div>
                      );
                    })}
                  </Flex>
                </Flex>
              );
            })}
          </div>
        </AffectedComponents>
      ) : null}
    </CardWrapper>
  );
};

export default IncidentCard;
